import * as t from "io-ts";

export const ImportTypeValidator = t.intersection([
  t.type({
    name: t.string,
    code: t.string,
    mimeType: t.string,
  }),
  t.partial({
    template: t.string,
  }),
]);

export const ImportTypeArrayValidator = t.array(ImportTypeValidator);

export type ImportType = t.TypeOf<typeof ImportTypeValidator>;
